import { usePackagePaymentModalContext } from "~/contexts/PackagePaymentModalContext";

const usePackagePaymentModal = () => {
	const { openPaymentModal, closePaymentModal } = usePackagePaymentModalContext();
	return { openPaymentModal, closePaymentModal };
};

export default usePackagePaymentModal;
